const u = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600`;

export const CONTACT = {
  email: "info@carving.in",
  phone: "+919747575166",
  phoneDisplay: "+91 97475 75166",
  instagram: "https://instagram.com/gokul.kv",
  instagramHandle: "@gokul.kv",
  maps: "https://share.google/D5qigpxcORmYcSj5E",
  google: "https://share.google/D5qigpxcORmYcSj5E",
  googleReview: "https://search.google.com/local/writereview?placeid=ChIJQbYyZfsnpDsRYbl6p1uA8pY",
  whatsapp: "https://wa.me/919747575166?text=Hi%20Carvings%20Architecture%2C%20I%27d%20like%20to%20discuss%20a%20project.",
  ga6: "https://www.ga6.in",
  address: "3rd Floor, Daliya Arcade, NCC Road, Pilakool, Thalassery, Kerala 670101",
};

export const STATS = [
  { value: "95K+", label: "Instagram followers" },
  { value: "600+", label: "Posts & site stories" },
  { value: "Kannur", label: "Based in Thalassery" },
];

export const IMAGES = {
  hero: "/ig/ajeer-residence-payyanur.jpg",
  portrait: "/ig/gokul-kv-new.jpg",
  studio: u("photo-1603901622056-0a5bee231395"),
  light: u("photo-1770844063644-4d8b91b980ce"),
};

export const PROJECTS = [
  { id: "p1", title: "Ajeer Residence", category: "Design", location: "Payyanur", client: "Ajeer", image: "/ig/ajeer-residence-payyanur.jpg", description: "3D visualisation of a contemporary Kerala home with sloped roofs, warm timber-clad gables and a landscaped front court." },
  { id: "p2", title: "Thillankeri — Kuttiyadikkal", category: "Construction", location: "Thillankeri", image: "/ig/thillankeri-foundation.jpg", description: "The traditional stone-laying ceremony marking the start of construction, with the Carvings Group team and the client on site." },
  { id: "p3", title: "Laterite Masonry", category: "Construction", image: "/ig/laterite-masonry.jpg", description: "Walls rising in Kerala laterite stone, laid course by course by our masons." },
  { id: "p4", title: "Structure in Progress", category: "Construction", image: "/ig/structure-in-progress.jpg", description: "A home taking shape on site, from slab and columns to the first walls." },
  { id: "p5", title: "Site Work", category: "Construction", image: "/ig/site-work.jpg", description: "Site levelling and setting out before the foundation begins." },
  { id: "p6", title: "On Site", category: "Construction", image: "/ig/renovation-site.jpg", description: "Regular site visits to keep every project on track, documented on our Instagram." },
];

// Renovation before/after pairs for the compare slider. SAMPLE images — replace with real project photos.
export const RENOVATIONS = [
  { id: "r1", title: "Family home, Kannur", location: "Kannur", year: "2025", before: "/renovation/before.jpg", after: "/renovation/after.jpg", note: "Weathered 1980s house restored with microcement walls, a new timber door, larger glazing and a landscaped front court." },
];

// Rough renovation rates (INR per sq ft of built-up area) for Kerala. Indicative only — edit as prices change.
export const COST_GUIDE = {
  areaMin: 600, areaMax: 5000, areaStep: 50, defaultArea: 1500,
  finishes: [
    { id: "essential", label: "Essential", rate: [900, 1300], text: "Repairs, waterproofing, fresh plaster and paint, basic electrical and plumbing." },
    { id: "comfort", label: "Comfort", rate: [1400, 2000], text: "Everything in Essential plus new kitchen, bathrooms, flooring, doors and windows." },
    { id: "premium", label: "Premium", rate: [2200, 3200], text: "Full redesign with microcement finishes, designer lighting, custom joinery and landscape." },
  ],
  extras: [
    { id: "roof", label: "Roof & structure", rate: [250, 450], text: "Re-roofing, beams, slab repair" },
    { id: "exterior", label: "Exterior & landscape", rate: [150, 300], text: "Facade, compound wall, garden" },
    { id: "interiors", label: "Interiors & furniture", rate: [400, 800], text: "Wardrobes, modular kitchen, loose furniture" },
    { id: "extension", label: "Extension / new floor", rate: [600, 1000], text: "Adding rooms or a first floor" },
  ],
};

export const GA6_PHOTOS = [
  { src: "/ga6/bathroom.jpg", alt: "Seamless microcement bathroom with integrated basin", label: "Wet areas" },
  { src: "/ga6/living.jpg", alt: "Polished microcement floor in a sunlit living room", label: "Floors" },
  { src: "/ga6/texture.jpg", alt: "Close-up of hand-trowelled microcement wall texture", label: "Walls" },
];

export const CATEGORIES = ["All", "Design", "Construction"];

// From the studio's Google Business listing (5.0 rating, 7 reviews).
export const GOOGLE_RATING = { score: "5.0", count: 7 };
export const TESTIMONIALS = [];

// Most popular reels from instagram.com/gokul.kv (sorted by likes). Thumbnails saved locally.
export const REELS = [
  { code: "DVK02soE_j2", title: "A change nobody expected", tag: "Renovation", likes: "204K", date: "Feb 2026" },
  { code: "DD98AQIyo7t", title: "Happy Christmas, Thalassery", tag: "Team", likes: "131K", date: "Dec 2024" },
  { code: "CxsjI5-vwEe", title: "Thiruvananthapuram site", tag: "Site visit", likes: "7.5K", date: "Sep 2023" },
  { code: "DA_-FGPzNRt", title: "Carvings Architecture", tag: "Studio", likes: "2.6K", date: "Oct 2024" },
  { code: "DXLqzX8jCN-", title: "Why cracks appear", tag: "Site tips", likes: "2K", date: "Apr 2026" },
  { code: "C1mP6adrOhn", title: "Under construction, TVM", tag: "Construction", likes: "559", date: "Jan 2024" },
  { code: "C73-BT_vVJe", title: "Chirakkuni, Palayad site", tag: "Site visit", likes: "534", date: "Jun 2024" },
  { code: "Dd-oESCsJvB", title: "Work issues we see on site", tag: "Site tips", likes: "518", date: "Oct 2026" },
].map((r) => ({ ...r, image: `/ig/reels/${r.code}.jpg`, url: `https://www.instagram.com/reel/${r.code}/`, embed: `https://www.instagram.com/reel/${r.code}/embed/` }));

export const SERVICES = [
  { n: "01", title: "Architectural Design", text: "Plans and elevations for homes and buildings, shaped around your site, budget and the way your family lives." },
  { n: "02", title: "3D Visualisation", text: "Realistic 3D views so you can see your dream home before construction begins." },
  { n: "03", title: "Construction", text: "From the foundation ceremony to handover, our team builds and supervises the work on site." },
  { n: "04", title: "Renovation", text: "Transforming older homes into contemporary living spaces." },
];

export const PROCESS = [
  { n: "I", title: "Listen", text: "We begin with your needs, your site and your budget." },
  { n: "II", title: "Concept", text: "Sketches, models and early ideas to find the right direction." },
  { n: "III", title: "Develop", text: "Detailed drawings, materials and interiors refined together." },
  { n: "IV", title: "Build", text: "Close coordination on site until the keys are handed over." },
];
